import styled from 'styled-components';

export const ProfileContainerStyled = styled.div`
  padding: 17px 30px 98px 30px;
`;
